import React, { Component } from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'
import moment from 'moment'
import FontAwesome from 'react-fontawesome'
import Pagination from 'react-js-pagination'

import Box from '../components/Layout/Box'
import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'

import ModalCreate from '../components/Plantillas/ModalCreate'
import ModalDelete from '../components/Plantillas/ModalDelete'
import ModalFilter from '../components/Plantillas/ModalFilter'
import store from '../utils/store'

import {
    getPlantillas,
	toggleSelectItem,
	toggleSelectAllItems,
	filterPlantillas,
	setOrderBy,
	displayModalCreate,
	showHideModalDelete,
	deletePlantillas,
    changeRecordsToShow,
    showHideModalFilter,
} from '../actions/plantillas'

export const tableCols = [
    { Id: 1, Caption: 'Tipo documento', Value: 'tipo', Type: 'string', Format: '', Width: '12%' },
    { Id: 2, Caption: 'Nombre', Value: 'nombre', Type: 'string', Format: '', Width: '20%', LinkToEdit: true },
    { Id: 3, Caption: 'Plantilla', Value: 'texto', Type: 'html', Format: '', Width: '68%' },
]

export function findValues(c, x) {
    const enums = store.getState().common.get('enums').toJS()
 	let value = x.getIn(c.Value.split('.'))
    if (c.Id === 1) {
        if (value) {
            value = enums.documentos.tipos[value].NOMBRE
        } else if (value === 0) {
            value = "Notificación"
        }
    }
	return value
}

class Plantillas extends Component {
    componentWillMount() {
        this.props.getPlantillas(1)
    }

	render() {
        const { plantillas, orderBy, page, totalRecords, showRecords, enums } = this.props

        const boxActions = [
            <BoxButton key="ba[0]" name="plus-circle" onClick={ e => this.props.displayModalCreate(true, 'Creación de plantillas', 'create') } title="Nuevo plantilla"/>,
            <BoxButton key="ba[1]" name="trash" onClick={ e => this.props.showHideModalDelete(true, `Esta seguro que desea eliminar los Plantillas seleccionados?`, () => this.props.deletePlantillas()) } disabled={ plantillas.filter(x => x.get('selected')).count() === 0 } danger title="Eliminar parámetro" />,
            <BoxButton key="ba[2]" name="filter" onClick={ e => this.props.showHideModalFilter(true) } title="Filtro"/>,
        ]

        const pagination = <Pagination
                            activePage={ page }
                            itemsCountPerPage={ showRecords }
                            totalItemsCount={ totalRecords }
                            pageRangeDisplayed={ 10 }
                            onChange={ (pg) => this.props.getPlantillas(pg)  }
                            firstPageText={ <FontAwesome name="angle-double-left" /> }
                            prevPageText={ <FontAwesome name="angle-left" /> }
                            nextPageText={ <FontAwesome name="angle-right" /> }
                            lastPageText={ <FontAwesome name="angle-double-right" /> }
                        />

		return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <Box title="Plantillas disponibles" stretch>
                        <ButtonStrip 
                            actions={ boxActions }
                            totalRecords={ totalRecords }
                            showRecords={ showRecords }
                            changeRecordsToShow={ (records) => this.props.changeRecordsToShow(records) }
                            pagination={ pagination }
                        />
                        <div className="box-content" style={{ flex: 1, height: 0, overflow: 'auto' }}>
                            <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-plantillas">
                                <thead>
                                    <tr>
                                        <th width="20px">
                                            <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={ e => this.props.toggleSelectAllItems(e.target.checked) } checked={ plantillas.filter(x => x.get('selected')).count() > 0 && plantillas.filter(x => x.get('selected') && x.get('visible')).count() >= plantillas.filter(x => x.get('visible')).count() } />
                                        </th>
                                        {
                                            tableCols.map(x => {
                                                const style = { width: `${x.Width}` }
                                                return (
                                                    <th key={ `th1[${x.Id}]` } style={ style } onClick={ e => this.props.setOrderBy(x) } className={ (orderBy.get('field') === x.Value) ? (orderBy.get('asc') ? 'asc' : 'desc') : '' }>{ x.Caption }</th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        plantillas.filter(x => x.get('visible')).count() > 0 ? plantillas.filter(x => x.get('visible')).map((x, c) => {
                                            if (!x.get('visible')) return null
                                            return (
                                                <tr key={ `tr1[${x.get('id')}]` } className={ x.get('selected') ? 'info' : '' }>
                                                    <td>
                                                        <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={ e => this.props.toggleSelectItem(c, e.target.checked) } checked={ x.get('selected') } />
                                                    </td>
                                                    {
                                                        tableCols.map(c => {
                                                            let alignment = 'left'
                                                            let value = findValues(c, x)
                                                            if (c.Type) {
                                                                switch (c.Type) {
                                                                    case 'datetime':
                                                                        value = moment(value).format(c.Format)
                                                                        alignment = 'right'
                                                                        break
                                                                    case 'bool':
                                                                        if (typeof value === 'string') value = parseInt(value, 10)
                                                                        value = <div style={{ textAlign: 'center', fontSize: '1.1em' }}><i className={`fa fa-${value ? 'check-' : ''}square`} /></div>
                                                                        break
                                                                    case 'number':
                                                                        value = numeral(value).format(c.Format)
                                                                        alignment = 'right'
                                                                        break
                                                                    case 'html':
                                                                        value = <div style={{ maxHeight: '10vh', overflowX: 'hidden' }} dangerouslySetInnerHTML={{ __html: value }} />
                                                                        break
                                                                    default:
                                                                }
                                                            }
                                                            const style = { textAlign: alignment }

                                                            if (c.LinkToEdit) {
                                                                return (
                                                                    <td key={ `td1[${x.get('id')}][${c.Id}]` } className='LinkToEdit' style={ style } onClick={ e => this.props.displayModalCreate(true, 'Modificación de plantillas', 'edit', x.get('id')) }>{ value }</td>
                                                                )
                                                            } else {
                                                                return (
                                                                    <td key={ `td1[${x.get('id')}][${c.Id}]` } style={ style }>{ value }</td>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </tr>
                                            )
                                        }) : <tr><td colSpan={ tableCols.length + 1 }>No existen registros</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Box>
                </div>
				<ModalCreate />
                <ModalDelete />
                <ModalFilter />
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        plantillas: state.plantillas.get('plantillas'),
        orderBy: state.plantillas.get('orderBy'),
        totalRecords: state.plantillas.get('totalRecords'),
        showRecords: state.plantillas.get('showRecords'),
        page: state.plantillas.get('page'),
        enums: state.common.get('enums').toJS(),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getPlantillas: (page) => dispatch(getPlantillas(page)),
		toggleSelectItem: (index, checked) => dispatch(toggleSelectItem(index, checked)),
		toggleSelectAllItems: (checked) => dispatch(toggleSelectAllItems(checked)),
		filterPlantillas: (term) => dispatch(filterPlantillas(term)),
		setOrderBy: (field) => dispatch(setOrderBy(field)),
		displayModalCreate: (show, title, mode, id) => dispatch(displayModalCreate(show, title, mode, id)),
		showHideModalDelete: (open, message, action) => dispatch(showHideModalDelete(open, message, action)),
		deletePlantillas: () => dispatch(deletePlantillas()),
        changeRecordsToShow: (records) => dispatch(changeRecordsToShow(records)),
        showHideModalFilter: (state) => dispatch(showHideModalFilter(state)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Plantillas)


// WEBPACK FOOTER //
// ./src/containers/Plantillas.jsx